<template>
    <el-dialog :title="(codeId === null ? $t('common.create') : $t('common.update')) + ' ' + $t('masters.symptomCode')" :visible.sync="showDialog" @open="loadCode" @close="closeDialog" width="500px" :close-on-click-modal="false">
        <el-form v-loading="loading" ref="form" :model="form" :rules="rules" size="small" label-width="140px" label-position="left">
            <el-form-item :label="$t('common.product')" prop="productId">
                <product-selector v-model="form.productId"></product-selector>
            </el-form-item>
            <el-form-item :label="$t('common.category')" prop="category" v-if="form.productId == 97">
                <el-input type="textarea" v-model="form.category"></el-input>
            </el-form-item>
            <el-form-item :label="$t('masters.subCategory')" prop="subCategory" v-if="form.productId == 97">
                <el-input type="textarea" v-model="form.subCategory"></el-input>
            </el-form-item>
            <el-form-item :label="$t('common.code')" prop="code">
                <el-input v-model="form.code"></el-input>
            </el-form-item>

            <el-form-item :label="$t('common.description')" prop="description">
                <el-input type="textarea" v-model="form.description"></el-input>
            </el-form-item>

            <el-form-item :label="$t('masters.mandatoryParts')">
                <part-selector @part-selected="mandatoryPartSelected"
                               :disabled="disableForm"
                               :title="$t('masters.toAddAnotherPartPleaseStartTypingNameOrPartNumber')"></part-selector>
            </el-form-item>

            <el-table :data="form.mandatoryParts"
                      class="tablewithshading"
                      size="mini">
                <br />
                <el-table-column :label="$t('common.partNum')"
                                 width="100">
                    <template slot-scope="scope">
                        <el-tooltip effect="dark"
                                    :content="scope.row.name"
                                    placement="top">
                            <el-tag type="info"
                                    size="small"
                                    :disable-transitions="true"
                                    style="margin-right:5px;">{{scope.row.partNo}}</el-tag>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('common.partDescription')">
                    <template slot-scope="scope">
                        <small>{{scope.row.name}}</small>
                    </template>
                </el-table-column>

                <el-table-column
                                 fixed="right"
                                 width="50">
                    <template slot-scope="scope">
                        <el-button size="mini"
                                   type="danger"
                                   @click="removeMandatoryPart(scope.row.id)">
                            <i class="el-icon-delete"></i>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <br />
            <el-form-item :label="$t('masters.recommendedParts')">
                <part-selector @part-selected="recommendedPartSelected"
                               :disabled="disableForm"
                               :title="$t('masters.toAddAnotherPartPleaseStartTypingNameOrPartNumber')"></part-selector>
            </el-form-item>
            <br />
            <el-table :data="form.recommendedParts"
                      class="tablewithshading"
                      size="mini">
                <el-table-column :label="$t('common.partNum')"
                                 width="100">
                    <template slot-scope="scope">
                        <el-tooltip effect="dark"
                                    :content="scope.row.name"
                                    placement="top">
                            <el-tag type="info"
                                    size="small"
                                    :disable-transitions="true"
                                    style="margin-right:5px;">{{scope.row.partNo}}</el-tag>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('common.partDescription')">
                    <template slot-scope="scope">
                        <small>{{scope.row.name}}</small>
                    </template>
                </el-table-column>
                <el-table-column
                                 fixed="right"
                                 width="50">
                    <template slot-scope="scope">
                        <el-button size="mini"
                                   type="danger"
                                   @click="removeRecommendedPart(scope.row.id)">
                            <i class="el-icon-delete"></i>
                        </el-button>
                    </template>
                </el-table-column>


            </el-table>
        </el-form>
        <span slot="footer">
            <el-button :disabled="loading" type="primary" @click="save" v-if="$isFullAdmin">{{codeId === null ? $t('common.create') : $t('common.update')}}</el-button>
            <el-button :disabled="loading" @click="closeDialog">{{$t('common.cancel')}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import { ProductSelector, PartSelector } from '@/app/shared/components'
    import api from '../api'
    export default {
        name: 'create-update-complaint-code-dialog',
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            codeId: {
                required: false
            }
        },
        components: {
            ProductSelector,
            PartSelector
        },
        data() {
            return {
                form: {
                    productId: null,
                    code: '',
                    description: '',
                    category: '',
                    mandatoryParts: [],
                    recommendedParts: []
                },
                rules: {
                    productId: [
                        {
                            type: 'number',
                            required: true,
                            message: this.$t('common.pleaseSelectProduct'),
                            trigger: 'change'
                        }
                    ],
                    code: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterCode'),
                            trigger: 'blur'
                        }
                    ],
                    description: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEntercodeDescription'),
                            trigger: 'blur'
                        }
                    ],
                    category: [
                        {
                            type: 'string',
                            required: true,
                            message: this.$t('common.pleaseEnterCategory'),
                            trigger: 'blur'
                        }
                    ]
                },
                loading: false,
                showDialog: this.visible,
                disableForm: false
            }
        },
        watch: {
            visible: function (val) {
                this.showDialog = val
            }
        },
        methods: {
            loadCode() {
                if (this.codeId) {
                    this.loading = true
                    api.getCode(this.codeId).then(response => {
                        this.loading = false
                        this.form = Object.assign({}, response.data)
                    })
                }
            },
            closeDialog() {
                this.showDialog = false
                this.loading = false
                this.$emit('dialogClosed')
                this.form.mandatoryParts = [];
                this.form.recommendedParts = [];
                this.$refs['form'].resetFields()
            },
            save() {
                this.$refs['form'].validate(valid => {
                    if (this.form.description.length > 500) {
                        this.$notify({
                            title: "Error",
                            message: this.$t('masters.descriptionlengtherror'),
                            type: "error"
                        });
                    }
                    else {
                        this.$refs['form'].validate(valid => {
                            if (valid) {
                                this.loading = true
                                api.saveCode(this.codeId, this.form).then((response) => {
                                    this.$emit('save', {
                                        new: this.codeId === undefined,
                                        id: this.codeId,
                                        data: this.form
                                    })
                                    this.closeDialog()
                                })
                            } else {
                                return false
                            }
                        })
                    }
                })
            },
            mandatoryPartSelected(addedPart) {
                console.log(addedPart);
                var part = this.form.mandatoryParts.find(p => p.id === addedPart.id);
                if (part === undefined) {
                    this.form.mandatoryParts.push(addedPart);
                }
            },
            recommendedPartSelected(addedPart) {
                console.log(addedPart);
                var part = this.form.recommendedParts.find(p => p.id === addedPart.id);
                if (part === undefined) {
                    this.form.recommendedParts.push(addedPart);
                }
            },
            removeMandatoryPart(id) {
                var part = this.form.mandatoryParts.find(p => p.id === id);
                if (part !== undefined) {
                    var index = this.form.mandatoryParts.indexOf(part);
                    if (index !== -1) this.form.mandatoryParts.splice(index, 1);
                    //this.form.mandatoryParts.remove(part);
                }
            },

            removeRecommendedPart(id) {
                var part = this.form.recommendedParts.find(p => p.id === id);
                if (part !== undefined) {
                    var index = this.form.recommendedParts.indexOf(part);
                    if (index !== -1) this.form.recommendedParts.splice(index, 1);
                    //this.form.recommendedParts.remove(part);
                }
            },

        }
    }
</script>


// WEBPACK FOOTER //
// ClientApp/app/masters/complaintcodes/components/CreateUpdateComplaintCodeDialog.vue